import { AxiosError, AxiosInstance } from 'axios';
import { getExceptionFromAxiosError } from '../helpers';
import { BeeFreeRequest, BeeFreeResponse } from './types';

export const beeFreeService = (client: AxiosInstance) => {
  const BEE_FREE_BASE_URL = 'integrations/bee-free';

  const getBeeFreeToken = async (
    payload: BeeFreeRequest,
  ): Promise<BeeFreeResponse> => {
    try {
      const { data } = await client.post<BeeFreeResponse>(
        BEE_FREE_BASE_URL,
        payload,
      );

      return data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  return {
    getBeeFreeToken,
  };
};
